// src/pages/GoodbyeAlex.js
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./GoodbyeAlex.css";
import rabbits from "../assets/rabbits.PNG";

const md = `
# Blip

*March 24, 2026*

> *“It’s hard coming back here and remembering that everything I ever loved and needed is here”*

I don’t know if you meant it to mean what it means. I’m not there where you are right now. But everything you loved and needed is there. Meaning you don’t love nor need me? Or is the past tense an important component to consider here.

I wonder if you at first typed “Stuart would be united against you” and then changed it to something a little less direct but with the same message. Now that I consider it, I’m almost certain that’s what you did.

This is why I need to build outside of the little life we hold in Berkeley. It becomes so difficult in practice once you text me, and I need warmth, or somewhere where I can be comfortable for a little while. That is truly the most dangerous part of how I am living right now. I am only comfortable in that home, that room, I crawled there after my car crash and cried to a drunk Alex.

I spend so much of my days revolving around someone to whom I’m little more than a blip. I want to run, starve, lay on Dashas floor and drink wine. I want to spend all night in the GIF lab and then groggily walk to Edmonds for a peppermint mocha.

I long for anything beyond being your life preserver in the treacherous waters of the East Bay.

Your struggles with losing someone you loved from your life is far different than what I’ve experienced. I’m going back in my memories, only to find that everyone who I’ve loved is either still in my life or dead. Losing someone to the heavens is so different than losing someone who is still circling you, shining brighter than ever.

If that were to happen to me I would do much more than drop out of school.

You would always tell me to find someone else to have sex with in Spain or New Jersey. At first I thought it was jokingly but now I realize you probably meant it. If I were to ask “were you serious?” your response would surely be something like: “when am I ever serious?” And then I’m right back where I started.

To my core I am so certain that she didn’t end things because of where you were in school and in life. You were only a sophomore. That wouldn’t have made any sense. You hurt her more than she could take. I’m too cowardly to ask her questions but I think I know all the right ones to ask. The only thing she probably couldn’t tell me is when it’s my turn to reach my limit.

This line still baffles me, I still don’t know how to respond to it. Who ever knows how to console someone? You went to sleep with your best friends and the beautiful family that loves you to pieces. I went to sleep aching. 2 days later you destroyed any faith I had in our little family.

![Rabbits](${rabbits} "rabs")
`;

export default function GoodbyeAlex() {
  return (
    <main className="mag-container">
      <article className="mag-article">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
      </article>
    </main>
  );
}